import { render } from "./basicDataMap.vue?vue&type=template&id=49e6e19e&scoped=true"
import script from "./basicDataMap.vue?vue&type=script&lang=js"
export * from "./basicDataMap.vue?vue&type=script&lang=js"

import "./basicDataMap.vue?vue&type=style&index=0&id=49e6e19e&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e6e19e"]])

export default __exports__